// File: frontend/src/pages/Capabilities/components/PricingCard.js

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import LandingButton from '../../../components/Button/LandingButton';
import styles from './PricingCard.module.css';

const PricingCard = ({ 
  id, 
  title, 
  price, 
  description, 
  features, 
  cta, 
  ctaLink, 
  highlight 
}) => {
  return (
    <motion.div 
      className={`${styles.card} ${highlight ? styles.highlightCard : ''}`}
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      {highlight && (
        <div className={styles.popularBadge}>
          Most Popular
        </div>
      )}
      
      <div className={styles.cardHeader}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.price}>{price}</div>
        <p className={styles.description}>{description}</p>
      </div>
      
      <ul className={styles.featuresList}>
        {features.map((feature, index) => (
          <li key={index} className={styles.featureItem}>
            <Check className={styles.checkIcon} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      
      <div className={styles.cardFooter}>
        <LandingButton 
          href={ctaLink} 
          className={`${styles.ctaButton} ${highlight ? styles.highlightButton : ''}`}
        >
          {cta}
        </LandingButton>
      </div>
    </motion.div>
  );
};

PricingCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  cta: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  highlight: PropTypes.bool
};

export default PricingCard;